<template>
    <div>
        123
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>